<div
  clickOutside
  (clickOutside)="handleClickOutside()"
  [attr.data-qa]="testIdPrefix"
  ngbDropdown
  #dropdown="ngbDropdown"
  (openChange)="onDropdownChange($event)"
  [placement]="placement"
  [autoClose]="false"
>
  <rx-calendar-input
    ngbDropdownAnchor
    [dateLabel]="datePickerLocale.inputLabel"
    [placeholder]="dateFormat"
    [dateFormat]="dateFormat"
    [fromDate]="datePickerRange.startDate"
    [toDate]="datePickerRange.endDate"
    [isOpen]="dropdown?.isOpen()"
    [testIdPrefix]="testIdPrefix"
    [compact]="compact"
    (click)="dropdown.isOpen() ? dropdown.close(): dropdown.open()"
  />
  <div ngbDropdownMenu class="date-picker__dropdown" @collapseExpand>
    <ng-container *ngIf="dateTypeOptions?.length">
      <rx-calendar-date-type
        *ngIf="dropdown?.isOpen()"
        [selectedDateType]="datePickerRange.dateType"
        [dateTypeLabel]="datePickerLocale.dateTypeLabel"
        [dateTypeOptions]="dateTypeOptions"
        [testIdPrefix]="testIdPrefix"
        (dateTypeChange)="onDateTypeChange($event)"
      />
      <hr />
    </ng-container>
    <ng-container *ngIf="showTabs; then tabs else customRange"></ng-container>
      <hr/>
    <rx-calendar-footer
      [startDate]="this.dateSelectionService.selectedStartDate$ | async"
      [endDate]="this.dateSelectionService.selectedEndDate$ | async"
      [dateFormat]="dateFormat"
      [resetText]="datePickerLocale.cancelLabel"
      [applyText]="datePickerLocale.applyLabel"
      [testIdPrefix]="testIdPrefix"

      (clickReset)="onResetDateRange()"
      (clickApply)="onApplyDateRange()"
    />
  </div>
</div>
<ng-template #tabs>
  <rx-tab-group
  (tabChange)="onTabChange($event)" [resetSelectedTab$]="resetSelectedTab$.asObservable()">
    <rx-tab-item
      [title]="datePickerLocale?.customRangeLabel" [tabId]="DatepickerTab.CustomRange" [testId]="testIdPrefix + '-custom-range-tab'">
      <ng-container  *ngTemplateOutlet="customRange"></ng-container>
    </rx-tab-item>
    <rx-tab-item
      [title]="datePickerLocale?.monthLabel" [tabId]="DatepickerTab.Month" [testId]="testIdPrefix + '-month-tab'">
      <div class="months-tab">
        <rx-calendar-months
          [minDate]="datePickerRange.minDate"
          [maxDate]="datePickerRange.maxDate"
          [resetTabSelections$]="resetTabSelections$.asObservable()"
          [testIdPrefix]="testIdPrefix"
          (selectionChange)="selectionChange($event)"
          ></rx-calendar-months>
      </div>
    </rx-tab-item>
  </rx-tab-group>
</ng-template>

<ng-template #customRange>
  <div class="d-flex">
    <div class="date-picker__selection">
      <rx-calendar-navigation
        *ngIf="dropdown?.isOpen()"
        [leftStartDate]="this.dateConversionService.toNgbDate(datePickerRange.startDate)"
        [rightStartDate]="this.dateConversionService.getNextMonth(datePickerRange.startDate)"
        [selectedDates]="this.dateSelectionService.selectedDates$ | async"
        [minDate]="datePickerRange.minDate"
        [maxDate]="datePickerRange.maxDate"
        [datePickerInstance]="dateSelection.datePicker"
        [selectedDateType]="datePickerRange.dateType"
        [testIdPrefix]="testIdPrefix"
      />
      <rx-calendar-date-selection
        #dateSelection
        [startDate]="datePickerRange.startDate"
        [minDate]="datePickerRange.minDate"
        [maxDate]="datePickerRange.maxDate"
        [testIdPrefix]="testIdPrefix"
      />
    </div>
    <rx-calendar-quick-selection
      *ngIf="(layoutService.isMobile$ | async) === false && datePickerLocale?.ranges?.length"
      [quickSelectionOptions]="datePickerLocale?.ranges"
      [selectedDates]="this.dateSelectionService.selectedDates$ | async"
      [testIdPrefix]="testIdPrefix"
      [selectedDateType]="datePickerRange.dateType"
      [isOpen]="dropdown?.isOpen()"
      (quickSelection)="onQuickSelection($event)">
    </rx-calendar-quick-selection>
  </div>
</ng-template>